// Copyright 2024, Imprivata, Inc.  All rights reserved.

export const WEB_APP_NAME = 'idp-web';
